/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Codec_Pcm_S16leInputs */

const en_audio_embed_export_codec_pcm_s16le = /** @type {(inputs: Audio_Embed_Export_Codec_Pcm_S16leInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PCM 16-bit`)
};

const fr_audio_embed_export_codec_pcm_s16le = /** @type {(inputs: Audio_Embed_Export_Codec_Pcm_S16leInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PCM 16 bits`)
};

const de_audio_embed_export_codec_pcm_s16le = /** @type {(inputs: Audio_Embed_Export_Codec_Pcm_S16leInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PCM 16-Bit`)
};

const it_audio_embed_export_codec_pcm_s16le = /** @type {(inputs: Audio_Embed_Export_Codec_Pcm_S16leInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PCM a 16 bit`)
};

const ru_audio_embed_export_codec_pcm_s16le = /** @type {(inputs: Audio_Embed_Export_Codec_Pcm_S16leInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PCM 16-бит`)
};

const es_audio_embed_export_codec_pcm_s16le = /** @type {(inputs: Audio_Embed_Export_Codec_Pcm_S16leInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PCM de 16 bits`)
};

const zh_cn2_audio_embed_export_codec_pcm_s16le = /** @type {(inputs: Audio_Embed_Export_Codec_Pcm_S16leInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PCM 16 位`)
};

const ja_audio_embed_export_codec_pcm_s16le = /** @type {(inputs: Audio_Embed_Export_Codec_Pcm_S16leInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PCM 16ビット`)
};

const hi_audio_embed_export_codec_pcm_s16le = /** @type {(inputs: Audio_Embed_Export_Codec_Pcm_S16leInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पीसीएम 16-बिट`)
};

const pt_pt2_audio_embed_export_codec_pcm_s16le = /** @type {(inputs: Audio_Embed_Export_Codec_Pcm_S16leInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PCM de 16 bits`)
};

/**
* | output |
* | --- |
* | "PCM 16-bit" |
*
* @param {Audio_Embed_Export_Codec_Pcm_S16leInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_codec_pcm_s16le = /** @type {((inputs?: Audio_Embed_Export_Codec_Pcm_S16leInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Codec_Pcm_S16leInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_codec_pcm_s16le(inputs)
	if (locale === "de") return de_audio_embed_export_codec_pcm_s16le(inputs)
	if (locale === "it") return it_audio_embed_export_codec_pcm_s16le(inputs)
	if (locale === "ru") return ru_audio_embed_export_codec_pcm_s16le(inputs)
	if (locale === "es") return es_audio_embed_export_codec_pcm_s16le(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_codec_pcm_s16le(inputs)
	if (locale === "ja") return ja_audio_embed_export_codec_pcm_s16le(inputs)
	if (locale === "hi") return hi_audio_embed_export_codec_pcm_s16le(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_codec_pcm_s16le(inputs)
	return en_audio_embed_export_codec_pcm_s16le(inputs)
});